import { SrNflGameStatusEnum } from "@/graphql/gql/graphql";
import { Game } from "./types";

export type NflGameState = "PRE" | "LIVE" | "POST";

export type GameStatusEnum = {
  [key in SrNflGameStatusEnum]: NflGameState;
};

const gameStatusMap: GameStatusEnum = {
  [SrNflGameStatusEnum.Scheduled]: "PRE",
  [SrNflGameStatusEnum.Created]: "PRE",
  [SrNflGameStatusEnum.InProgress]: "LIVE",
  [SrNflGameStatusEnum.Halftime]: "LIVE",
  [SrNflGameStatusEnum.Complete]: "POST",
  [SrNflGameStatusEnum.Closed]: "POST",
  [SrNflGameStatusEnum.Cancelled]: "PRE",
  [SrNflGameStatusEnum.Postponed]: "PRE",
  [SrNflGameStatusEnum.TimeTbd]: "PRE",
  [SrNflGameStatusEnum.FlexSchedule]: "PRE",
  [SrNflGameStatusEnum.Delayed]: "PRE",
  [SrNflGameStatusEnum.Suspended]: "PRE",
};

export const findGameState = (game: Game): NflGameState => {
  const gameState: NflGameState = gameStatusMap[game.status ?? "SCHEDULED"];

  if (gameState === "POST") {
    return "POST";
  }
  if (game.clock?.toLowerCase() === "event over") {
    return "POST";
  }
  if (gameState === "LIVE") {
    return "LIVE";
  }

  const gameTime = new Date(game.scheduledTime ?? "");
  const currentTime = new Date();
  const timeToGame = gameTime.getTime() - currentTime.getTime();

  if (gameState === "PRE" && game.clock === null && timeToGame > 0) {
    return "PRE";
  }

  if (game.clock !== null || timeToGame < 0) {
    return "LIVE";
  }

  return gameState;
};
